// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/humidity-dewpoint.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/humidity-dewpoint/humidity-dewpoint.js';

mount([g0]);
